<template>
  <div class="container mt-4">
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div v-if="mensajeProceso" :class="['alert alert-dismissible', mensajeProceso.tipo]">
      {{ mensajeProceso.texto }}
      <button type="button" class="btn-close" @click="mensajeProceso = null"></button>
    </div>

    <!-- Formulario: solo visible al crear o editar -->
    <suscripcion-form
      v-if="mostrarFormulario"
      :edit-mode="!!suscripcionToEdit"
      :suscripcion-to-edit="suscripcionToEdit"
      @suscripcion-added="handleSuscripcionAdded"
      @suscripcion-updated="handleSuscripcionUpdated"
      @cancel-edit="handleCancelEdit"
    />

    <suscripcion-list
      :suscripciones="suscripciones"
      :mostrarTodas="mostrarTodas"
      @suscripcion-deleted="loadSuscripciones"
      @suscripcion-changed="loadSuscripciones"
      @edit="startEdit"
      @toggle-mostrar-todas="toggleMostrarTodas"
      @nuevo="abrirFormulario"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import axios from '../config/axios';
import SuscripcionForm from '../components/SuscripcionForm.vue';
import SuscripcionList from '../components/SuscripcionList.vue';

export default {
  name: 'SuscripcionesView',

  components: {
    SuscripcionForm,
    SuscripcionList
  },

  setup() {
    const store = useStore();
    const error = ref(null);
    const suscripcionToEdit = ref(null);
    const mostrarFormulario = ref(false);
    const mensajeProceso = ref(null);
    const mostrarTodas = ref(true); // el filtro de estado de la lista decide qué se muestra

    const suscripciones = computed(() => store.state.suscripciones.suscripciones);

    const loadSuscripciones = async () => {
      try {
        error.value = null;
        await store.dispatch('suscripciones/fetchSuscripciones', mostrarTodas.value);
        suscripcionToEdit.value = null;
        mostrarFormulario.value = false;
      } catch (err) {
        console.error('Error:', err);
        error.value = 'Error al cargar las suscripciones';
      }
    };

    const abrirFormulario = () => {
      suscripcionToEdit.value = null;
      mostrarFormulario.value = true;
      // Desplazar al formulario suavemente
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 50);
    };

    const handleSuscripcionAdded = () => {
      loadSuscripciones();
    };

    const handleSuscripcionUpdated = () => {
      loadSuscripciones();
      suscripcionToEdit.value = null;
      mostrarFormulario.value = false;
    };

    const startEdit = (suscripcion) => {
      suscripcionToEdit.value = { ...suscripcion };
      mostrarFormulario.value = true;
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 50);
    };

    const handleCancelEdit = () => {
      suscripcionToEdit.value = null;
      mostrarFormulario.value = false;
    };

    const toggleMostrarTodas = () => {
      mostrarTodas.value = !mostrarTodas.value;
      loadSuscripciones();
    };

    onMounted(loadSuscripciones);

    return {
      suscripciones,
      error,
      suscripcionToEdit,
      mostrarFormulario,
      startEdit,
      abrirFormulario,
      loadSuscripciones,
      handleSuscripcionAdded,
      handleSuscripcionUpdated,
      handleCancelEdit,
      mensajeProceso,
      mostrarTodas,
      toggleMostrarTodas
    };
  }
};
</script>
